import React, { type ComponentProps } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { Button } from '@garnish/core';

import { useFloatingBottomBarSpacing } from '@order/shared-hooks';

export const BagUseCardButton = (props: ComponentProps<typeof Button>) => {
  const { disabled = false, style, ...restProps } = props;
  const { floatingBottomBarStyle } = useFloatingBottomBarSpacing();

  return (
    <View style={[styles.container, floatingBottomBarStyle]}>
      <Button
        palette="primary"
        size="large"
        disabled={disabled}
        style={[styles.button, style, disabled && styles.disabledButton]}
        {...restProps}
      >
        <FormattedMessage {...messages.useCard} />
      </Button>
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  useCard: {
    defaultMessage: 'Use card',
    description: 'Bag | Payment method | Use card',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    left: theme.spacing['4'],
    right: theme.spacing['4'],
  },
  button: {
    minHeight: 64,
  },
  disabledButton: {
    backgroundColor: theme.colors.LIGHT,
  },
});
